// extracted by mini-css-extract-plugin
export default {"content":"ingredient-details_content__Bj3Vw","image":"ingredient-details_image__C3eCe","subtitle":"ingredient-details_subtitle__a4INe","props":"ingredient-details_props__tDZ6c"};